export const CHECKBOX_CHANGE_FIELD = '@@checkboxer/CHANGE_FIELD';
export const CHECKBOX_REGISTER_FIELD = '@@checkboxer/REGISTER_FIELD';
export const CHECKBOX_UNREGISTER_FIELD = '@@checkboxer/UNREGISTER_FIELD';
